(function () {
  function uniqueId(length = 10) {
    return Date.now().toString(36) + Math.random().toString(36).substring(length);
  }

  // Open lightbox on image click
  document.querySelectorAll(".js-lightboxGallery").forEach(function (gallery) {
    // Initialize Swiper inside lightbox
    let lightboxSwiper = null;
    const galleryUID = gallery.dataset.galleryUid ? gallery.dataset.galleryUid : uniqueId();

    function initSwiperLightbox() {
      /* eslint-disable no-undef */
      lightboxSwiper = new Swiper("#js-swiperLightbox-" + galleryUID, {
        touchEventsTarget: "wrapper",
        // Optional parameters
        lazy: true,
        slidesPerView: 1.25,
        spaceBetween: 20,
        grabCursor: true,
        // Navigation arrows
        navigation: {
          nextEl: ".ux-swiper-button-next",
          prevEl: ".ux-swiper-button-prev",
          disabledClass: "is-disabled",
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        // if we need change by devices
        breakpoints: {
          1024: {
            slidesPerView: 1.05,
            spaceBetween: 20,
          },
        },
      });
      /* eslint-enable */
    }

    if (gallery) {
      const medias = gallery.querySelectorAll(".js-galleryItem");
      const html = document.documentElement;
      let slidesHtml = "";

      medias.forEach(function (item) {
        // Check if item has attributs for lightbox image or child is an image
        if (
          (item.hasAttribute("lightbox-src") && item.hasAttribute("lightbox-alt")) ||
          item.children[0].tagName === "IMG"
        ) {
          // Create custom element
          const customElem = document.createElement("div");
          customElem.classList.add("ci-Lightbox-itemMedia");

          // Get image source and alt attributes
          const src = item.getAttribute("lightbox-src") || item.children[0].getAttribute("src");
          const alt = item.getAttribute("lightbox-alt") || item.children[0].getAttribute("alt");
          const slideClass = item.getAttribute("lightbox-class");

          // Create image element
          const imgElem = document.createElement("img");
          imgElem.setAttribute("src", src);
          imgElem.setAttribute("alt", alt);

          const slide = document.createElement("div");
          slide.classList.add("swiper-slide", "ci-Lightbox-item");
          if (slideClass) {
            slide.classList.add(slideClass.split(" "));
          }

          customElem.appendChild(imgElem);
          slide.appendChild(customElem);
          slidesHtml += slide.outerHTML;
        } else {
          // Create custom element
          const customElem = document.createElement("div");

          if (!item.children[0].querySelector(".ux-responsive-container")) {
            customElem.classList.add("ux-responsive-container");
          }

          let customElemHtml = "";
          // Ajouter la balise HTML de l'élément iframe
          customElemHtml += item.children[0].outerHTML;

          const slide = document.createElement("div");
          slide.classList.add("swiper-slide", "ci-Lightbox-item");

          // Put the HTML tag in the custom div
          customElem.innerHTML = customElemHtml;
          // Add the custom div in the slide
          slide.appendChild(customElem);
          slidesHtml += slide.outerHTML;
        }
      });

      // Generate lightbox HTML
      const lightboxHtml = `
			<div class="ci-Lightbox">
				<div id="js-swiperLightbox-${galleryUID}" class="ci-Lightbox-content swiper swiper--noSpacing">
					<div class="swiper-wrapper">
						${slidesHtml}
					</div>
					<div class="ux-swiper-button-prev"></div>
					<div class="ux-swiper-button-next"></div>
				</div>
				<button class="ci-Lightbox-close">&times;</button>
				<div class="ux-backdrop"></div>
			</div>
    `;

      // Add lightbox to the page
      gallery.insertAdjacentHTML("beforeend", lightboxHtml);

      const lightbox = gallery.querySelector(".ci-Lightbox");

      // Open lightbox on item click
      medias.forEach(function (item) {
        item.addEventListener("click", function (e) {
          // Desktop only
          if (window.innerWidth >= 1024) {
            e.preventDefault();
            e.stopPropagation();

            lightbox.classList.add("is-open");
            html.classList.add("no-scroll");

            // Get the index of the item from the gallery
            const index = parseInt(item.closest(".js-galleryItem").getAttribute("data-index")) - 1;
            // Move the slide corresponding to the index of the item in the gallery
            lightboxSwiper.slideTo(index);
          }
        });
      });

      // Close lightbox on close button click
      const closeButton = lightbox.querySelector(".ci-Lightbox-close");
      const closeLightBox = function () {
        // Stop all players in iframe or video when closing the lightbox

        lightbox.querySelectorAll("video, iframe").forEach(function (element) {
          if (element.tagName.toLowerCase() === "video") {
            element.pause();
            // Utilisation de dispatchEvent pour déclencher l'événement "pause"
            element.dispatchEvent(new Event("pause"));
          } else if (element.tagName.toLowerCase() === "iframe") {
            const iframeSrc = element.src;
            // Réaffectation de la source pour arrêter la vidéo dans l'iframe
            element.src = iframeSrc;
          }
        });

        lightbox.classList.remove("is-open");
        html.classList.remove("no-scroll");
      };

      closeButton.addEventListener("click", closeLightBox);

      // Close lightbox on overlay click
      const overlay = gallery.querySelector(".ux-backdrop");
      overlay.addEventListener("click", closeLightBox);
    }

    // Load event
    initSwiperLightbox();
  });
})();
